module.exports = __webpack_public_path__ + "static/media/leadDetails.2c6bc6ba.png";